/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){

    $('.js-recover-password').on('click', function(){
      $('#login').hide();
      $('#recover-password').show();
      $('.heading-wrapper--login').hide();
    });

    $('.cancel-recover-password').on('click', function(){
      $('#recover-password').hide();
      $('#login').show();
      $('.heading-wrapper--login').show();
    })

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;